import { DrawerContainer } from '../components/DrawerContainer'

export const Home = () => {
 return (
   <div>
      <DrawerContainer/>
   </div>
 )
}